/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
import router from '../router'
axios.defaults.baseURL = '/api/v1/'

export default new Vuex.Store({
  strict: true,
  state: {
    parques: [{}, {}, {}],
    vouchers: [],
    institucional: [],
    fechado: [] as any[],
    passaportes: [] as any[],
    hoje: '',
    carrinho: {
      id: undefined,
      parque: localStorage.getItem('parque') || '',
      data: localStorage.getItem('dataVisita') || '',
      forma_pagamento: 0,
      parcelas: 1,
      passaportes: [] as any[],
      tarifas: [] as any[],
      valor: 0,
      itens: 0,
      voucher: '',
      pix: '',
      payment_id: 0,
      processing: false
    },
    voucher: {},
    pedidos: [],
    logadoSocio: false,
    logadoVisitante: false,
    dialogLogin: false,
    dialogPedidos: false,
    dialogCartao: false,
    successCartao: false,
    successPIX: false,
    dialogErro: false,
    mensagemErro: '',
    visitante: {
      cpf: ''
    },
    socio: { cpf: '', matricula: ''},
    token: {},
    meusPedidos: [],
    erroAjax: '',
    goToAfterLogin: '',
    mostraCarrinho: true,
    loading: false
  },
  getters: {
    listaPassaportes: state => parque => state.passaportes.filter(x => x.parque === parque ),
    totalCarrinho: state => state.carrinho.passaportes.reduce((soma, x) => soma + x.total, 0),
    totalCarrinhoTarifas: state => state.carrinho.tarifas.reduce((soma, x) => soma + x.valor, 0),
    totalIngressos: state => state.carrinho.passaportes.reduce((soma, x) => soma + x.quantidade, 0),
    getTarifas: state => state.carrinho.tarifas
  },
  mutations: {
    toggleDialogLogin: (state) => (state.dialogLogin = !state.dialogLogin),
    toggleDialogPedidos: (state) => (state.dialogPedidos = !state.dialogPedidos),
    toggleDialogCartao: (state) => (state.dialogCartao = !state.dialogCartao),
    toggleSuccessCartao: (state) => (state.successCartao = !state.successCartao),
    toggleDialogErro: (state) => (state.dialogErro = !state.dialogErro),
    setLoading: (state, payload) => state.loading = payload,
    limpaCarrinho: (state) => {
      state.carrinho = {
        id: undefined,
        parque: localStorage.getItem('parque') || '',
        data: localStorage.getItem('dataVisita') || '',
        forma_pagamento: 0,
        parcelas: 1,
        passaportes: [] as any[],
        tarifas: [] as any[],
        valor: 0,
        itens: 0,
        voucher: '',
        pix: '',
        payment_id: 0,
        processing: false
      }
      state.voucher = {}
      localStorage.setItem('carrinho', '')
    },
    setErroAjax: (state, payload) => {
      state.erroAjax = payload
    },
    setVouchers: (state, payload) => {
      state.vouchers = payload
    },
    setMensagemErro: (state, payload) => {
      state.mensagemErro = payload
      if (payload != '')
        state.dialogErro = true
      else
        state.dialogErro = false
    },
    trataErroAjax: (state, error) => {
      state.loading = false
      if (error.response) {
        state.erroAjax = error.response.data.message
      } else if (error.request) {
        state.erroAjax = error.request
      } else {
        state.erroAjax = error.message
      }
    },
    setDados: (state, payload) => {
      state.hoje = payload.hoje
      state.parques = payload.parques
      state.institucional = payload.institucional
      for (let i=0;i<state.parques.length;i++) {
        let fechado = payload.fechado.filter(x => x.parque === i)
        state.fechado[i] = [];
        for (let j=0;j<fechado.length;j++) {
          state.fechado[i].push(fechado[j]['data'])
        }
      }
      state.passaportes = payload.passaportes
      try { state.carrinho.passaportes = JSON.parse(localStorage.getItem('carrinho') || '[]') } catch {}
    },
    setParque: (state, payload) => {
      state.carrinho.parque = payload
      localStorage.setItem('parque', payload)
      state.carrinho.data = ''
    },
    setData: (state, payload) => {
      state.carrinho.data = payload
      localStorage.setItem('dataVisita', payload)
    },
    setCPF: (state, payload) => {
      state.visitante.cpf = payload
    },
    setVoucher: (state, payload) => {
      state.voucher = payload
    },
    setMostraCarrinho: (state, payload) => {
      state.mostraCarrinho = payload
    },
    setID: (state, payload) => {
      state.carrinho.id = payload.id
      state.carrinho.valor = Math.round(payload.valor*100)/100
      state.carrinho.voucher = payload.voucher
      state.carrinho.pix = payload.pix
    },
    setPaymentId: (state, payload) => {
      state.carrinho.payment_id = payload
    },
    setFormaPagamento: (state, payload) => {
      state.carrinho.forma_pagamento = payload
    },
    updateCarrinho: (state, payload: any[]) => {
      state.carrinho.passaportes = payload
      state.carrinho.tarifas = []
      localStorage.setItem('carrinho', JSON.stringify(payload))
    },
    updateCarrinhoTarifas: (state, payload: any[]) => {
      state.carrinho.passaportes = []
      state.carrinho.tarifas = payload
    },
    updateCPF: (state, payload) => {
      state.visitante.cpf = payload
    },
    delCarrinho: (state, payload) => {
      state.carrinho.passaportes = state.carrinho.passaportes.filter(x => x.id !== payload)
    },
    loginVisitante: (state, payload) => { 
      state.logadoVisitante = true
      state.visitante = payload 
      state.token = payload.token
      localStorage.setItem('token', payload.token)
      axios.defaults.headers.common['Authorization'] = 'Bearer '+payload.token
    },
    setDialogLogin: (state, payload) => { 
      state.dialogLogin = payload
    },
    logoutVisitante: (state, payload) => { 
      state.logadoVisitante = false
      state.visitante = { cpf: '' } 
    },
    loginSocio: (state, payload) => { 
      state.logadoSocio = true
      state.socio = payload 
      state.token = payload.token
      localStorage.setItem('token', payload.token)
      axios.defaults.headers.common['Authorization'] = 'Bearer '+payload.token
    },
    setMeusPedidos: (state, payload) => { 
      state.meusPedidos = payload
    },
    goToAfterLogin: (state, payload) => { 
      state.goToAfterLogin = payload
    },
    setProcessing: (state, payload) => { 
      state.carrinho.processing = payload
    }
  },
  actions: {
    getDados: ({ commit }) => {
      axios.get('update').then(response => commit('setDados', response.data))
    },
    consultaVouchers: ({ commit }) => {
      const vouchers = JSON.parse(localStorage.getItem("vouchers") || '[]');
      axios.post('consulta/vouchers', {vouchers})
      .then(result => {
        const usados = result.data.data.filter(itm => itm.status == 3);
        let vouchers = JSON.parse(localStorage.getItem("vouchers") || '[]');
        usados.map(usado => {
          vouchers = vouchers.filter(v => v != usado.voucher)
        })
        localStorage.setItem("vouchers", JSON.stringify(vouchers))
        const validados = result.data.data.filter(itm => itm.status == 2);
        console.log('validados', validados);
        commit('setVouchers', validados)
      });
    },
    consultaVoucher: ({ commit, state }) => {
      if (state.carrinho.voucher != '') {
        const vouchers = [state.carrinho.voucher];
        axios.post('consulta/vouchers', {vouchers})
        .then(result => {
          const validados = result.data.data.filter(itm => itm.status == 2)[0];
          if (validados) {
            router.push('/voucher/'+state.carrinho.voucher)
          }
        });
      }
    },
    setMensagemErro: ({ commit, state }, payload) => {
      commit('setMensagemErro', payload)
      setTimeout(() => {
        commit('setMensagemErro', '')
        router.push('/selecione/parque')
      }, 3000)
    },
    getCPF: ({ commit, state }, payload) => {
      commit('setLoading', true)
      return axios.get('auth/cpf/'+payload)
      .then(result => {
        commit('setLoading', false)
        console.log(result.data.data)
        if (result.data.data.id)
          commit('loginVisitante', result.data.data)
        else
          if (result.data)
            commit('updateCPF', payload) 
        
        return result
      }).catch(erro => commit('trataErroAjax', erro))
    },
    goToPagamento: ({ commit, state }, payload) => {
      if (state.logadoVisitante) {
        router.push('/pagamento/selecione')
      } else {
        commit('goToAfterLogin', '/pagamento/selecione')
        commit('toggleDialogLogin')
      }
    },
    cadastrarVisitante: ({ commit, state }, payload) => {
      return axios.post('cadastro', payload)
      .then(result => {
        if (result.data)
          commit('updateCPF', payload) 
        commit('loginVisitante', result.data.data)
        return result
      }).catch(erro => commit('trataErroAjax', erro))
    },
    loginVisitante: ({ commit }, payload) => {
      commit('setLoading', true)
      return axios.post('auth/visitante', payload)
      .then(result => {
        commit('setLoading', false)
        if (result.data) {
          commit('setMeusPedidos', result.data.data)
          commit('toggleDialogPedidos');
        }
        //   commit('loginVisitante', result.data.data)
        // router.push(payload.to)
        return result.data
      }).catch(erro => commit('trataErroAjax', erro))
    },
    loginSocio: ({ commit }, payload) => {
      commit('setLoading', true)
      return axios.post('auth/socio', payload)
      .then(result => {
        commit('setLoading', false)
        if (result.data) 
          commit('loginSocio', result.data.data)
        router.push('/socio/area-socio')
        return result
      }).catch(erro => commit('trataErroAjax', erro))
    },
    updateCarrinho: ({ commit, state }, payload) => {
      let carrinho = state.carrinho.passaportes.filter(x => x.id !== payload.id)
      payload.total = payload.valorPromo * payload.quantidade
      if (payload.quantidade > 0)
        carrinho.push(payload)
      commit('updateCarrinho', carrinho)
    },
    selecionaFormaPagamento: ({ commit, getters, state }, payload) => {
      commit('setFormaPagamento', payload)
      let carrinho = Object.assign({ 
        voucher: state.carrinho.voucher,
        visitante: state.visitante, 
        total: getters.totalCarrinho+getters.totalCarrinhoTarifas, 
        itens: getters.totalIngressos 
      }, state.carrinho)
      return axios.post('pedido', carrinho)
      .then(result => {
        if (result.data) {
          commit('setID', result.data.data)
          let vouchers = JSON.parse(localStorage.getItem("vouchers") || '[]');
          let newSet = new Set([...vouchers, result.data.data.voucher])
          localStorage.setItem("vouchers", JSON.stringify([...newSet]))    
        }
        return result
      }).catch(erro => commit('trataErroAjax', erro))
    },
    pagamentoCartaoCredito: ({ commit, dispatch, state }, payload) => {
      if (!state.carrinho.processing) {
        commit('setProcessing', true)
        //console.log(payload)
        //console.log(state)
        commit('setMensagemErro', '')
        commit('toggleDialogCartao')
        let pagamento = {
          pedido: state.carrinho.id,
          cardHolderName: payload.cardName,
          cardNumber: payload.cardNumberNotMask.replace(/[^0-9.]/g, ""),
          securityCode: payload.cardCvv,
          expirationYear: payload.cardYear,
          expirationMonth: payload.cardMonth,
          installments: payload.installments,
          amount: state.carrinho.valor
        }
        return axios.post('pagamento/rede/credit', pagamento)
        .then(result => {
          commit('toggleDialogCartao') 
          commit('toggleSuccessCartao')
          if (state.socio.cpf != '') {
            setTimeout(() => {
              commit('setMensagemErro', '')
              commit('toggleSuccessCartao')
              dispatch('loginSocio', {matricula: state.socio.matricula, cpf: state.socio.cpf })
              commit('limpaCarrinho')
            }, 3000)
          } else {
            setTimeout(() => {
              commit('setMensagemErro', '')
              commit('toggleSuccessCartao')
              const carrinho = Object.assign({}, state.carrinho)
              commit('limpaCarrinho')
              router.push('/voucher/'+carrinho.voucher)
            }, 3000)
          }
          commit('setProcessing', false)
          return result.data
        }).catch(erro => {
          commit('trataErroAjax', erro)
          commit('setProcessing', false)
          setTimeout(() => { 
            commit('toggleDialogCartao') 
            commit('setErroAjax', '')
          }, 5000)
        })
      }
    },
    pagamentoCartaoDebito: ({ commit, state }, payload) => {
      if (!state.carrinho.processing) {
        commit('setProcessing', true)
        //console.log(payload)
        //console.log(state)
        commit('setMensagemErro', '')
        commit('toggleDialogCartao')
        let pagamento = {
          pedido: state.carrinho.id,
          voucher: state.carrinho.voucher,
          cardHolderName: payload.cardName,
          cardNumber: payload.cardNumberNotMask.replace(/[^0-9.]/g, ""),
          securityCode: payload.cardCvv,
          expirationYear: payload.cardYear,
          expirationMonth: payload.cardMonth,
          installments: state.carrinho.parcelas,
          amount: state.carrinho.valor
        }
        return axios.post('pagamento/rede/debit', pagamento)
        .then(result => {
          //console.log(result.data)
          commit('limpaCarrinho')
          commit('setProcessing', false)
          location.href=result.data.data
          return result.data
        }).catch(erro => {
          commit('trataErroAjax', erro)
          commit('setProcessing', false)
          setTimeout(() => { 
            commit('toggleDialogCartao') 
            commit('setErroAjax', '')
          }, 5000)
        })
      }
    },
    pagamentoCartaoBanricompras: ({ commit, dispatch, state }, payload) => {
      //console.log(payload)
      //console.log(state)
      commit('setMensagemErro', '')
      commit('setPaymentId', 0)
      commit('toggleDialogCartao')
      let forma = 2;
      if (state.carrinho.forma_pagamento === 3) {
        forma = 1
      }
      let url = state.carrinho.id+'/'+forma+'/'+state.carrinho.valor+'/'+state.carrinho.parcelas
      return axios.get('pagamento/banricompras/'+url)
      .then(result => {
        commit('setPaymentId', result.data.data.payment_id)
        window.open(result.data.data.url)
        setTimeout(() => { 
          dispatch('consultaPagamentoBanricompras')
        }, 5000)
        return result.data
      }).catch(erro => {
        commit('trataErroAjax', erro)
        setTimeout(() => { 
          commit('toggleDialogCartao') 
          commit('setErroAjax', '')
        }, 5000)
      })
    },
    consultaPagamentoBanricompras: ({ commit, dispatch, state }) => {
      if (state.carrinho.payment_id > 0) {
        return axios.get('pagamento/banricompras/consulta/' + state.carrinho.payment_id)
        .then(result => {
          console.log(result)
          switch (result.data.data.situacao) {
            case 'NÃO AUTORIZADO':
              commit('toggleDialogCartao') 
              commit('setMensagemErro', result.data.data.situacao)
              break;
            case 'AUTORIZADO':
              commit('toggleDialogCartao') 
              commit('toggleSuccessCartao')
              const carrinho = Object.assign({}, state.carrinho)
              commit('limpaCarrinho')
              if (state.socio.cpf != '') {
                setTimeout(() => {
                  commit('setMensagemErro', '')
                  commit('toggleSuccessCartao')
                  dispatch('loginSocio', {matricula: state.socio.matricula, cpf: state.socio.cpf })
                }, 3000)
              } else {
                setTimeout(() => {
                  commit('setMensagemErro', '')
                  commit('toggleSuccessCartao')
                  commit('limpaCarrinho')
                  router.push('/voucher/'+carrinho.voucher)
                }, 3000)
              }
              break;
            default:
              setTimeout(() => { 
                dispatch('consultaPagamentoBanricompras') 
              }, 5000)
              break;
          }
          return result.data
        }).catch(erro => {
          commit('trataErroAjax', erro)
          setTimeout(() => { 
            commit('toggleDialogCartao') 
            commit('setErroAjax', '')
          }, 5000)
        })
      }
    },
    contato: ({ commit, state }, payload) => {
      return axios.post('contato', payload)
      .then(result => {
        console.log(result)
        return result
      }).catch(erro => commit('trataErroAjax', erro))
    },
    buscaVoucher: ({ commit, state }, payload) => {
      return axios.get('voucher/'+payload)
      .then(result => {
        commit('setVoucher', result.data.data)
        return result.data
      }).catch(erro => {
        commit('trataErroAjax', erro)
      })
    },
    meusPedidos: ({ commit, state }, payload) => {
      return axios.get('meuspedidos')
      .then(result => {
        commit('setMeusPedidos', result.data.data)
        return result.data
      }).catch(erro => {
        commit('trataErroAjax', erro)
      })
    }
  }
})
